const root = VUE_API_URI.rootURI;

export const apis = {
    /*============ 通用接口 : CommonController ============*/
    common_all_langs: root + '/commonApi/allLangs',
    common_conf_find: root + '/commonConfApi/findConfigByTableNames',
    common_configuration_find:root + '/commonApi/findConfigurationByKey',
    common_conf_calc_lineup: root + '/commonConfApi/calcLineup',

    /*============ 帐号 : AccountController ============*/
    account_login: root + '/accountApi/login',
    account_change_password: root + '/accountApi/changePassword',
    account_all_menu: root + '/accountApi/allMenu',

    /*============ 后台管理员 : AdminController ============*/
    admin_change_role: root + '/adminApi/changeAdminRole',
    admin_find: root + '/adminApi/findByRoleId',
    admin_save: root + '/adminApi/saveAdmin',
    admin_del: root + '/adminApi/delAdmin',
    admin_reset_password: root + '/adminApi/resetPassword',

    /*============ 角色权限 : Role Controller ============*/
    role_change: root + '/roleApi/changeRole',
    role_find: root + '/roleApi/findById',
    role_all: root + '/roleApi/findAll',
    role_save: root + '/roleApi/saveRole',

    /*============ 运维相关接口 : YunweiServerController============*/
    // 创建全服登陆服/通信服
    yunwei_server_save: root + '/yunweiServerApi/saveYunweiServer',
    // 修改白名单
    yunwei_server_white_list_modify: root + '/yunweiServerApi/modifyWhiteList',
    // 全局登录拦截
    yunwei_server_global_login_block_modify: root + '/yunweiServerApi/modifyGlobalLoginBlock',
    // 修改一键加群
    yunwei_server_join_modify: root + '/yunweiServerApi/modifyJoinKey',
    // 修改sdk异常公告
    yunwei_server_sdk_error_modify: root + '/yunweiServerApi/modifySdkError',
    // 修改登录服异常公告
    yunwei_server_login_error_modify: root + '/yunweiServerApi/modifyLoginError',

    // 修改排队速率和队列长度
    yunwei_server_login_queue_modify: root + '/yunweiServerApi/modifyLoginQueue',
    yunwei_login_configuration_modify: root + '/yunweiServerApi/modifyLoginConfiguration',

    /*============ 世界服接口合集 : BeastsWorldController ============*/
    // 世界服重载
    world_reload_config: root + '/beastsWorldApi/reloadConfig',
    // 世界服全部重载
    world_reload_all: root + '/beastsWorldApi/reloadAll',
    // 网关链接重载
    world_reload_connect: root + '/beastsWorldApi/reloadConnect',
    //读取表名
    world_get_table_name: root + '/beastsWorldApi/getTableName',

    world_cache_clear_setting: root + '/beastsWorldApi/clearSettingCache',

    world_cache_val: root + '/beastsWorldApi/getCacheValue',

    /*============ 调用游戏服的开放api合集 : BeastsGameController ============*/
    // 查询玩家
    game_player_find: root + '/beastsGameApi/findPlayers',
    game_player_detail: root + '/beastsGameApi/detailPlayer',
    game_monster_find: root + '/beastsGameApi/findMonstersByPlayerId',
    game_skin_find: root + '/beastsGameApi/findSkinsByPlayerId',
    game_emblems_find: root + '/beastsGameApi/findEmblemsByPlayerId',
    game_lineups_find: root + '/beastsGameApi/findLineupsByPlayerId',
    game_war_grooves_find: root + '/beastsGameApi/findWarGroovesByPlayerId',
    game_props_find: root + '/beastsGameApi/findPropsByPlayerId',
    game_main_city_find: root + '/beastsGameApi/findMainCityByPlayerId',
    // 封停角色
    game_block_role: root + '/beastsGameApi/blockRole',
    // 禁言账号
    game_forbid_speak: root + '/beastsGameApi/forbidSpeak',
    // 伪禁言账号
    game_fake_forbid_speak: root + '/beastsGameApi/fakeForbidSpeak',
    // 解放角色
    game_unblock_role: root + '/beastsGameApi/unblockRole',
    // 解除禁言
    game_allow_speak: root + '/beastsGameApi/allowSpeak',
    // 改名
    game_player_rename: root + '/beastsGameApi/rename',
    // 解除关联
    game_player_disconnect: root + '/beastsGameApi/disconnect',
    // 屏蔽玩家信息
    game_player_info_shield: root + '/beastsGameApi/infoShield',
    // 部落查询
    game_tribe_find: root + '/beastsGameApi/findTribes',
    // 充值查询
    game_charges_find: root + '/beastsGameApi/findCharges',
    // 留言查询
    game_mixed_msg_find: root + '/beastsGameApi/findMixedMessages',
    // 删除留言
    game_mixed_msg_del: root + '/beastsGameApi/delMixedMessage',
    // 聊天查询
    game_chat_log_find: root + '/beastsGameApi/findChatLogs',
    // 删除聊天
    game_chat_log_del: root + '/beastsGameApi/delChatLog',
    // 邮件查询
    game_mail_find: root + '/beastsGameApi/findMails',
    // 删除邮件
    game_mail_del: root + '/beastsGameApi/delMail',
    // 游戏服重载
    game_reload_config: root + '/beastsGameApi/reloadConfig',
    // 游戏服全部重载
    game_reload_all: root + '/beastsGameApi/reloadAll',
    //修改时间
    game_change_time: root + '/beastsGameApi/changeTime',
    //发道具
    game_send_item: root + '/beastsGameApi/sendItem',
    //解锁全怪兽
    game_unlock_monster: root + '/beastsGameApi/unlockMonster',
    //解锁地图点
    game_unlock_map: root + '/beastsGameApi/unlockMapNode',
    //全通部落冒险
    game_pass_tribe_adventures: root + '/beastsGameApi/passTribeAdventures',
    game_change_war_status: root + '/beastsGameApi/changeWarStatus',
    game_trigger_random_event: root + '/beastsGameApi/triggerRandomEvent',
    game_lv_monster: root + '/beastsGameApi/lvMonster',
    game_update_user_task: root + '/beastsGameApi/updateUserTask',
    //清理古战役排阵信息
    game_clear_ancient_campaign: root + '/beastsGameApi/clearAncientCampaign',
    // 填充部落
    game_fill_tribe: root + '/beastsGameApi/fillTribe',
    // 清除部落昵称
    game_rewrite_tribe_name: root + '/beastsGameApi/rewriteTribeName',
    // 清除部落公告
    game_rewrite_tribe_Bulletin: root + '/beastsGameApi/rewriteTribeBulletin',
    // 高级账号生成
    game_build_account: root + '/beastsGameApi/buildAccount',
    //读取表名
    game_get_table_name: root + '/beastsGameApi/getTableName',

    game_cache_clear_setting: root + '/beastsGameApi/clearSettingCache',

    game_cache_val: root + '/beastsGameApi/getCacheValue',
    game_queue_operation: root + '/beastsGameApi/loginQueueOperation',

    game_repush_order: root + '/beastsGameApi/repushOrder',
    game_ranking_info: root + '/beastsGameApi/rankingInfo',
    game_ranking_clear: root + '/beastsGameApi/rankingClear',
    game_deduct_item: root + '/beastsGameApi/deductItem',
    game_dot_tips: root + '/beastsGameApi/pushRedDotAll',

    find_transfer_by_tel: root + '/transferApi/findByTel',
    find_players_by_transfer: root + '/beastsGameApi/findPlayersByTransfer',

    // 查询岸腾sid的换绑记录
    get_record_by_quick_sid: root + '/globalTransferApi/getRecordByQuickSid',
    // 雷霆账号验证开关
    open_msg_record_by_quick_sid: root + '/globalTransferApi/openMsgRecordByQuickSid',
    // 刷新验证记录
    get_msg_record_by_quick_sid: root + '/globalTransferApi/getMsgRecordByQuickSid',
    // 查询雷霆sid的换绑记录
    get_record_by_leiting_sid: root + '/globalTransferApi/getRecordByLeitingSid',
    // 换绑
    submit_transfer: root + '/globalTransferApi/submitTransfer',
    // 换绑进度查询
    get_all_progress: root + '/globalTransferApi/allProgress',
    // 换绑进度单个查询
    get_progress: root + '/globalTransferApi/progress',
    // 待转绑信息查询
    list_by_finish_validate: root + '/globalTransferApi/listByFinishValidate',
    // 取消绑定
    cancel_bind: root + '/globalTransferApi/cancelBind',
    // 举报查询
    show_all_reports: root + '/gameReportApi/showAllReports',
    // 处理举报
    handle_reports: root + '/gameReportApi/handleReports',
    // 举报历史记录
    show_history: root + '/gameReportApi/showHistory',


    /*============ 登录服接口合集 : BeastsLoginController ============*/
    // 登录服重载
    login_reload_config: root + '/beastsLoginApi/reloadConfig',
    // 登录服全部重载
    login_reload_all: root + '/beastsLoginApi/reloadAll',

    login_reload_all_clzName: root + '/beastsLoginApi/reloadAllClzName',

    /*============ 登录服接口合集 : BeastsLoginController ============*/

    beasts_reload_config: root + '/beastsApi/reloadClzName',

    /*============ 调用战斗验算接口合集 : BeastsWarValidateController ============*/
    // node配置信息读取
    war_v2_core_get_local_config: root + '/beastsWarApi/v2CoreGetLocalConfig',
    // 运行coreRun
    war_v2_core_run: root + '/beastsWarApi/v2CoreRun',

    /*============ 策划工具 - 活动管理" : Activity Controller ============*/
    // 保存活动
    activity_save: root + '/activityApi/save',
    activity_temporarily_closed: root + '/activityApi/temporarilyClosed',
    activity_recover: root + '/activityApi/recover',
    activity_closed: root + '/activityApi/closed',
    activity_del: root + '/activityApi/del',
    activity_time_refresh: root + '/activityApi/timeRefresh',

    /*============ 开发者工具 - 操作日志管理 :BeastsMachineController ============*/
    // 维护战区
    beasts_machine_world_maintenance: root + '/beastsMachineApi/worldMaintenance',
    // 服务器注册开关
    beasts_machine_server_register_switch: root + '/beastsMachineApi/switchServerRegister',
    // 游戏服修改
    beasts_machine_change_game_machine_info: root + '/beastsMachineApi/changeGameMachineInfo',
    // 战区修改
    beasts_machine_change_world_machine_info: root + '/beastsMachineApi/changeWorldMachineInfo',

    /*============ 策划工具 - 配置管理 : Conf Controller ============*/
    // 读取当前数据
    conf_read_data: root + '/confApi/readData',
    // 修改业务参数
    conf_modify_business_configuration: root + '/confApi/modifyBusinessConfiguration',
    // 查询配置表以及最新更新时间
    conf_select_show_tables: root + '/confApi/showTables',

    // 上传excel并且更新配置库
    conf_upload_excel: root + '/confApi/uploadExcel',
    conf_upload: root + '/confApi/upload',

    // 自定义限制更新
    conf_function_switch:root + '/confApi/functionSwitch',

    // 查询版本更新
    conf_version_all: root + '/confVersionApi/allVersions',
    // 版本更新
    conf_version_update:root + '/confVersionApi/updateVersion',
    // 推送当前版本
    conf_version_push:root + '/confVersionApi/pushVersion',


    /*============ 策划工具 - 屏蔽字管理 : Mask Word Controller ============*/
    maskword_find: root + '/maskWordApi/findByWord',
    maskword_append: root + '/maskWordApi/appendWord',
    maskword_del: root + '/maskWordApi/delWord',
    maskword_refresh: root + '/maskWordApi/refreshWord',


    // 添加原因模板
    config_setting_reason_save: root + '/configSettingApi/addReason',
    // 原因模板列表
    config_setting_reason_list: root + '/configSettingApi/reasons',
    // 删除原因模板
    config_setting_reason_del: root + '/configSettingApi/delReason',
    // 添加言论标签
    config_setting_opinion_save: root + '/configSettingApi/addOpinion',
    // 言论标签列表
    config_setting_opinion_list: root + '/configSettingApi/opinions',
    // 删除言论标签
    config_setting_opinion_del: root + '/configSettingApi/delOpinion',
    // 增加渠道
    config_setting_channel_save: root + '/configSettingApi/addChannel',
    // 删除渠道
    config_setting_channel_del: root + '/configSettingApi/delChannel',
    // 渠道列表
    config_setting_channel_list: root + '/configSettingApi/channels',
    // 增加媒体值
    config_setting_media_save: root + '/configSettingApi/addMedia',
    // 删除媒体值
    config_setting_media_del: root + '/configSettingApi/delMedia',
    // 媒体值列表
    config_setting_media_list: root + '/configSettingApi/medias',

    /*============  邮件工具 - 邮件模板管理 : MailTemplateController ============*/
    // 邮件模板列表
    mail_template_find: root + '/mailTemplateApi/findByName',
    // 删除邮件模板
    mail_template_del: root + '/mailTemplateApi/delTemplate',
    // 修改邮件模板
    mail_template_modify: root + '/mailTemplateApi/modifyTemplate',
    // 创建邮件模板
    mail_template_save: root + '/mailTemplateApi/saveTemplate',
    //发普通邮件
    mail_normal_send: root + '/mailNormalApi/sendNormal',
    //普通邮件-查询全部
    mail_normal_find_all: root + '/mailNormalApi/findAll',
    //全局邮件-查询全部
    mails_system_find_all: root + '/mailSystemApi/findAll',
    //全局邮件-修改
    mails_system_modify: root + '/mailSystemApi/modify',
    //发全局邮件
    mails_system_send: root + '/mailSystemApi/send',
    // 批量邮件查询
    mail_batch_find_all: root + '/mailBatchApi/findAll',
    // 批量上传邮件
    mail_batch_send_by_excel: root + '/mailBatchApi/sendByUploadExcel',

    /*============ 推送广播 BroadcastController  ============*/
    broadcast_save: root + '/broadcastApi/saveBroadcast',
    broadcast_all: root + '/broadcastApi/findAllBroadcast',
    broadcast_change: root + '/broadcastApi/changeBroadcast',

    /*============ 公告管理 NoticeController  ============*/
    // 公告列表
    notice_list: root + '/noticeApi/allNotices',
    // 创建公告
    notice_send: root + '/noticeApi/sendNotice',
    // 编辑公告
    notice_edit: root + '/noticeApi/editNotice',
    // 删除公告
    notice_delete: root + '/noticeApi/deleteNotice',
    // 上传轮播图
    notice_banner_upload: root + '/noticeApi/uploadBanner',
    // 更新公告图
    notice_banner_modify: root + '/noticeApi/modifyBanner',
    // 公告图信息
    notice_banner_info: root + '/noticeApi/getBannerInfo',

    /*============ 崩坏引导管理 NoticeGuideController  ============*/
    // 公告列表
    notice_guide_list: root + '/noticeGuideApi/allNotices',
    // 创建公告
    notice_guide_send: root + '/noticeGuideApi/sendNotice',
    // 编辑公告
    notice_guide_edit: root + '/noticeGuideApi/editNotice',
    // 删除公告
    notice_guide_delete: root + '/noticeGuideApi/deleteNotice',

    /*============ 维护公告管理 NoticeMaintenanceController  ============*/
    // 维护公告列表
    notice_maintenances_list: root + '/noticeMaintenanceApi/allNoticeMaintenances',
    // 创建维护公告
    notice_maintenance_send: root + '/noticeMaintenanceApi/sendNoticeMaintenance',
    // 更新维护公告
    notice_maintenance_edit: root + '/noticeMaintenanceApi/editNoticeMaintenance',
    // 删除维护公告
    notice_maintenance_delete: root + '/noticeMaintenanceApi/deleteNoticeMaintenance',

    /*============ 语义化管理 langVersion Controller ============*/
    //获取所有语言版本
    lang_version_all: root + '/langVersionApi/getAll',
    //删除语言版本
    lang_version_delete: root + '/langVersionApi/deleteVersion',

    /*============ 策划工具 - 兑换码管理" : Exchange Controller ============*/
    exchange_show_all_sequences: root + '/exchangeCodeSettingApi/showAllSequences',
    exchange_show_gifts: root + '/exchangeCodeSettingApi/queryGiftsByPage',
    exchange_create_gift:root + '/exchangeCodeSettingApi/createGift',
    exchange_delete_gift:root + '/exchangeCodeSettingApi/deleteGift',
    exchange_export_excel: root + '/exchangeCodeSettingApi/exportExcel',
    exchange_find: root + '/exchangeCodeSettingApi/findCode',
    exchange_query:root + '/exchangeCodeSettingApi/queryCode',
    exchange_sum: root + '/exchangeCodeSettingApi/sumCode',
    exchange_create_sequence: root + '/exchangeCodeSettingApi/createSequence',
    exchange_update_sequence: root + '/exchangeCodeSettingApi/updateSequence',
    exchange_insert_code_sequence: root + '/exchangeCodeSettingApi/insertCodeBySequence',
    exchange_create_code: root + '/exchangeCodeSettingApi/createCode',
    exchange_ban_sequence: root + '/exchangeCodeSettingApi/banSequence',
    exchange_enable_sequence:root + '/exchangeCodeSettingApi/enableSequence',
    exchange_delete_sequence: root + '/exchangeCodeSettingApi/deleteSequence',
    exchange_ban_code: root + '/exchangeCodeSettingApi/banCode',
    exchange_supply_code: root + '/exchangeCodeSettingApi/supplyCode',
    exchange_code_history: root + '/exchangeCodeSettingApi/getUserExchangeHistory',



    /*============ 策划工具 - 对话编辑器" : DialogEditor Controller ============*/
    // 固化语言包
    random_event_lang_upload: root + '/randomEventApi/langUpload',
    // 剧本语言包
    random_event_langs: root + '/randomEventApi/langs',


    /*============ 运营工具 - 语义化管理 : LangConf Controller ============*/
    // 查询配置表以及最新更新时间
    lang_conf_get_all: root + '/langConfApi/getAllConf',
    lang_conf_export: root + '/langConfApi/exportJson',
    lang_conf_excel_download: root + '/langConfApi/downloadExcel',
    lang_conf_cn_excel_upload: root + '/langConfApi/uploadLangExcel',
    lang_conf_types: root + '/langConfApi/collectTypes',
    // 上传语言包到OSS
    lang_conf_oss_upload: root + '/langConfApi/uploadToOSS',

    verify_upload_json : root + '/langConfApi/verify/uploadJson',
    verify_upload_excel: root + '/langConfApi/verify/uploadExcel',
    verify_get_list: root + '/langConfApi/verify/getCheckList',
    verify_get_uncheck_data: root + '/langConfApi/verify/getUncheckData',
    verify_finish: root + '/langConfApi/verify/finish',
    verify_back: root + '/langConfApi/verify/back',
    verify_down_verify_excel: root + '/langConfApi/verify/export/excel',
    verify_one_click: root + '/langConfApi/verify/oneClick',
    verify_compare: root + '/langConfApi/verify/compare',

    //Excel
    // 导出非中文版本的差异项全量Excel
    compare_current_version: root + '/langConfApi/otherLang/compareCurrentVersion',
    // 导出非中文版本的差异项全量Excel(海外)
    compare_oversea: root + '/langConfApi/otherLang/compareOversea',
    //上传对比过后Excel文档
    upload_lang_excel: root + '/langConfApi/otherLang/uploadLangExcel',
    //上传对比过后Excel文档(海外)
    upload_oversea_cn_excel: root + '/langConfApi/otherLang/uploadOverSeaCnExcel',
    //CSV
    // 导出非中文版本的差异项全量csv
    compare_current_version_csv: root + '/langConfApi/otherLang/compareCurrentVersion/csv',
    // 导出非中文版本的差异项全量csv(海外)
    compare_oversea_csv: root + '/langConfApi/otherLang/compareOversea/csv',
    //上传对比过后csv文档
    upload_lang_csv: root + '/langConfApi/otherLang/uploadLang/csv',
    //上传对比过后csv文档(海外)
    upload_oversea_csv: root + '/langConfApi/otherLang/uploadOverSea/csv',


    // 获取源初境冠军
    get_all_champion_record: root + '/originRealmApi/allRecord',
    // 获取源初境冠军(新)
    record_by_realm_season: root + '/beastsWorldApi/recordByRealmSeason',

    // 当前各服dau
    server_dau: root + '/beastsLoginApi/serverDau',
    // 分服充值  分服dau数据
    get_all_dau_records: root + '/tdRecordApi/getAllRecords',
}



// WEBPACK FOOTER //
// ./src/lib/apis.js